import { Badge, Card, Container } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import NewsComments from '../components/NewsComments';
import Loader from '../components/Loader';
import { useGetNewsPostBySlugQuery } from '../slices/newsApiSlice';

const NewsPostScreen = () => {
  const { slug } = useParams();
  const { data: post, isLoading, error } = useGetNewsPostBySlugQuery(slug);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="section-modern">
      <Container className="fade-in py-5" style={{ maxWidth: 880 }}>
        {error ? (
          <Card className="modern-card">
            <Card.Body className="text-danger">
              {error?.data?.message || 'Unable to load this update.'}
            </Card.Body>
          </Card>
        ) : post ? (
          <>
            <div className="mb-3">
              <Link to="/news" className="text-decoration-none">
                Back to all stories
              </Link>
            </div>
            <Card className="modern-card">
              <Card.Body className="p-4 p-lg-5">
                <div className="text-secondary small mb-2">
                  {post.publishedAt
                    ? new Date(post.publishedAt).toLocaleString()
                    : 'Draft'}
                </div>
                <h1 className="text-primary mb-3">{post.title}</h1>
                <p className="lead text-secondary mb-4">{post.summary}</p>
                {post.imageUrl ? (
                  <div className="mb-4">
                    <img
                      src={post.imageUrl}
                      alt={post.imageAlt || post.title}
                      style={{ width: '100%', borderRadius: '1rem', objectFit: 'cover', maxHeight: 460 }}
                    />
                  </div>
                ) : null}
                <div className="d-flex flex-wrap gap-2 mb-4">
                  {post.tags?.map((tag) => (
                    <Badge bg="light" text="dark" key={tag}>
                      {tag}
                    </Badge>
                  ))}
                </div>
                <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.75 }}>{post.body}</div>
              </Card.Body>
            </Card>
            <NewsComments post={post} />
          </>
        ) : null}
      </Container>
    </div>
  );
};

export default NewsPostScreen;
